import { render, staticRenderFns } from "./SelectCategory.vue?vue&type=template&id=e21d2264&scoped=true&"
import script from "./SelectCategory.vue?vue&type=script&lang=ts&"
export * from "./SelectCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21d2264",
  null
  
)

export default component.exports